import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import './tariff.scss';
import classNames from 'classnames';
import CalendarDatePage from './CalendarDatePage';
import TariffListPage from './TariffListPage';
import DailyTariffPage from './DailyTariffPage';
import TariffCostTestPage from './TariffCostTestPage';
import { getSystemData } from '../../System/reducer';
import ModuleUnavailableState from '../../../components/base/ModuleUnavailableState';
import { isMenuUnavailable } from '../../System/serviceAvailability';

export default function TariffPage() {
  const [tab, setTab] = useState(1);
  const { serviceAvailability } = useSelector(getSystemData);
  const isModuleUnavailable = isMenuUnavailable(serviceAvailability, 'menu.tariff');

  return (
    <div className="tariff-page page">
      {!isModuleUnavailable ? (
        <div className="tab-box">
          <div className="tab-menu">
            <div className={classNames('tab-item', { selected: tab === 1 })} onClick={() => setTab(1)}>Тарифы</div>
            <div className={classNames('tab-item', { selected: tab === 2 })} onClick={() => setTab(2)}>Рабочий календарь</div>
            <div className={classNames('tab-item', { selected: tab === 3 })} onClick={() => setTab(3)}>Дневные тарифы</div>
            <div className={classNames('tab-item', { selected: tab === 4 })} onClick={() => setTab(4)}>Тест тарифа</div>
          </div>
        </div>
      ) : null}

      {isModuleUnavailable ? <ModuleUnavailableState /> : null}
      {!isModuleUnavailable && tab === 1 ? <TariffListPage /> : null}
      {!isModuleUnavailable && tab === 2 ? <CalendarDatePage /> : null}
      {!isModuleUnavailable && tab === 3 ? <DailyTariffPage /> : null}
      {!isModuleUnavailable && tab === 4 ? <TariffCostTestPage /> : null}
    </div>
  );
}
